import { makeActionCreator } from '../../../utilities'
import { DestinationAddressConstants } from './destinationAddress.constants'

export const setTypeValue = makeActionCreator(DestinationAddressConstants.SET_TYPE, 'typeValue')
export const setOtherType = makeActionCreator(DestinationAddressConstants.SET_OTHER_TYPE, 'txToCode')
export const setHospitalInPatientDestination = makeActionCreator(
  DestinationAddressConstants.SET_HOSPITAL_IN_PATIENT_DESTINATION,
  'hospitalInPatientDestination'
)
export const setModeDescriptors = makeActionCreator(
  DestinationAddressConstants.SET_MODE_DESCRIPTORS,
  'addlTransportModeDescriptors'
)
export const setDestinationAddressModeDescriptorsPNNV = makeActionCreator(
  DestinationAddressConstants.SET_MODE_DESCRIPTORS_PNNV,
  'addlTransportModeDescriptorsPNNV'
)
export const setLocation = makeActionCreator(DestinationAddressConstants.SET_LOCATION, 'name')
export const setCommonAddress = makeActionCreator(DestinationAddressConstants.SET_COMMON_ADDRESS, 'commonAddress')
export const setAddressLine1 = makeActionCreator(DestinationAddressConstants.SET_ADDRESS_LINE1, 'addressLine1')
export const setAddressLine2 = makeActionCreator(DestinationAddressConstants.SET_ADDRESS_LINE2, 'addressLine2')
export const setAptSuiteRoom = makeActionCreator(DestinationAddressConstants.SET_APT_SUITE_ROOM, 'aptSuiteRoom')
export const setMilePostMajorRoadway = makeActionCreator(
  DestinationAddressConstants.SET_MILE_POST_MAJOR_ROADWAY,
  'milePostMajorRoadway'
)
export const setCrossStreetDirections = makeActionCreator(
  DestinationAddressConstants.SET_CROSS_STREET_DIRECTIONS,
  'crossStreetDirections'
)
export const setCity = makeActionCreator(DestinationAddressConstants.SET_CITY, 'city')
export const setState = makeActionCreator(DestinationAddressConstants.SET_STATE, 'state')
export const setZip = makeActionCreator(DestinationAddressConstants.SET_ZIP, 'zip')
export const setCountry = makeActionCreator(DestinationAddressConstants.SET_COUNTRY, 'country')
export const setCensusTract = makeActionCreator(DestinationAddressConstants.SET_CENSUS_TRACT, 'censusTract')
export const setCounty = makeActionCreator(DestinationAddressConstants.SET_COUNTY, 'county')
export const setReceivingRN = makeActionCreator(DestinationAddressConstants.SET_RECEIVING_RN, 'receivingNurse')
export const setReceivingMD = makeActionCreator(DestinationAddressConstants.SET_RECEIVING_MD, 'receivingMdText')
export const setReceivingUSNG = makeActionCreator(DestinationAddressConstants.SET_RECEIVING_USNG, 'usng')
export const setReceivingGPSN = makeActionCreator(DestinationAddressConstants.SET_RECEIVING_GPS_N, 'gpsn')
export const setReceivingGPSE = makeActionCreator(DestinationAddressConstants.SET_RECEIVING_GPS_E, 'gpse')
export const calculateReceivingUsng = makeActionCreator(DestinationAddressConstants.CALCULATE_RECEIVING_USNG)
export const setComment = makeActionCreator(DestinationAddressConstants.SET_COMMENT, 'comment')
export const setTransportMode = makeActionCreator(
  DestinationAddressConstants.SET_TRANSPORT_MODE,
  'transportModeFromScene'
)
export const setTransportModePNNV = makeActionCreator(
  DestinationAddressConstants.SET_TRANSPORT_MODE_PNNV,
  'transportModeFromScenePNNV'
)
export const saveDestinationAddress = makeActionCreator(DestinationAddressConstants.SAVE_DESTINATION_ADDRESS)
export const setResponse = makeActionCreator(DestinationAddressConstants.SET_RESPONSE, 'response')
export const setDispositionState = makeActionCreator(DestinationAddressConstants.SET_DISPOSITION_STATE, 'disposition')
export const resetDispositionState = makeActionCreator(DestinationAddressConstants.RESET_DISPOSITION_STATE)

export const setDestinationBasis = makeActionCreator(
  DestinationAddressConstants.SET_DESTINATION_BASIS,
  'reasonForChoosingDestination'
)
export const setDestinationBasisPNNV = makeActionCreator(
  DestinationAddressConstants.SET_DESTINATION_BASIS_PNNV,
  'reasonForChoosingDestinationPNNV'
)
export const setDestinationGrid = makeActionCreator(DestinationAddressConstants.SET_DESTINATION_GRID, 'grid')
export const setDestinationCapabilities = makeActionCreator(
  DestinationAddressConstants.SET_CAPABILITIES,
  'hospitalCapability'
)
export const setStateIds = makeActionCreator(DestinationAddressConstants.SET_STATE_IDS, 'stateIds')
export const setDestinationCapabilitiesPNNV = makeActionCreator(
  DestinationAddressConstants.SET_CAPABILITIES_PNNV,
  'hospitalCapabilityPNNV'
)
export const resetDestinationAddressStateOnTypeChange = makeActionCreator(
  DestinationAddressConstants.RESET_DESTINATION_ADDRESS_STATE_ON_TYPE_CHANGE
)
export const setDefaultHospitalCode = makeActionCreator(DestinationAddressConstants.SET_DEFAULT_HOSPITAL_CODE)
export const setDefaultEMSCode = makeActionCreator(DestinationAddressConstants.SET_DEFAULT_EMS_CODE)
export const setDestinationAddressDefaults = makeActionCreator(
  DestinationAddressConstants.SET_DESTINATION_ADDRESS_DEFAULTS,
  '__areDefaultsSet'
)
